// Point du jour — agrégation des chiffres (GET /decisionnel/point-jour) par découpage
// et mise en forme du message (WhatsApp / copier-coller).

export const DECOUPAGES = [
  { value: 'global',     label: 'Global' },
  { value: 'ville',      label: 'Par ville' },
  { value: 'projet',     label: 'Par projet' },
  { value: 'commercial', label: 'Par commercial' },
];

export const FORMATS = [
  { value: 'court',    label: 'Court' },
  { value: 'standard', label: 'Standard' },
  { value: 'detaille', label: 'Détaillé' },
];

export const BLOCS = [
  { id: 'hier', label: 'Hier', items: [
    { id: 'hier.ventes',  label: 'Ventes' },
    { id: 'hier.enc',     label: 'Encaissements' },
    { id: 'hier.liv',     label: 'Passages notaire' },
    { id: 'hier.impayes', label: 'Nouveaux impayés' },
    { id: 'hier.desist',  label: 'Désistements' },
  ] },
  { id: 'mois', label: 'Mois en cours vs objectif', items: [
    { id: 'mois.ventes', label: 'Ventes' },
    { id: 'mois.enc',    label: 'Enc. + Recouv.' },
    { id: 'mois.liv',    label: 'Livraisons' },
  ] },
  { id: 'annee', label: 'Cumul année vs objectif', items: [
    { id: 'annee.ventes', label: 'Ventes' },
    { id: 'annee.enc',    label: 'Enc. + Recouv.' },
    { id: 'annee.liv',    label: 'Livraisons' },
  ] },
  { id: 'n1', label: 'Comparaison', items: [
    { id: 'n1.ventes', label: 'Ventes du mois' },
    { id: 'n1.enc',    label: 'Encaissements du mois' },
  ] },
  { id: 'coms', label: 'Commerciaux', items: [
    { id: 'coms.top',        label: 'Meilleur commercial' },
    { id: 'coms.classement', label: 'Classement complet' },
  ] },
  { id: 'surv', label: 'À surveiller', items: [
    { id: 'surv.ptf',      label: 'Chèques PTF sous 7 j' },
    { id: 'surv.reliquat', label: 'Notaire non soldé' },
    { id: 'surv.bloque',   label: 'Notaire > 90 j' },
    { id: 'surv.retard',   label: 'Projets en retard' },
  ] },
  { id: 'impayes', label: 'Impayés en cours', items: [
    { id: 'impayes.total',     label: 'Total' },
    { id: 'impayes.anciennete', label: 'Ancienneté' },
  ] },
  { id: 'stock', label: 'Stock', items: [
    { id: 'stock.dispo', label: 'Lots disponibles' },
    { id: 'stock.taux',  label: 'Taux de commercialisation' },
  ] },
];

export const ALL_BLOCS = BLOCS.flatMap(g => g.items.map(i => i.id));

// Blocs cochés par défaut selon le type de rapport
export const TYPES_RAPPORT = [
  { value: 'quotidien', label: 'Quotidien', blocs: [
    'hier.ventes', 'hier.enc', 'hier.liv', 'hier.impayes', 'hier.desist',
    'mois.ventes', 'mois.enc', 'mois.liv',
    'surv.ptf', 'surv.bloque', 'surv.retard',
  ] },
  { value: 'hebdo', label: 'Hebdo', blocs: [
    'mois.ventes', 'mois.enc', 'mois.liv', 'annee.ventes', 'annee.enc', 'annee.liv',
    'coms.top', 'coms.classement', 'surv.ptf', 'surv.reliquat', 'surv.bloque', 'surv.retard',
    'impayes.total', 'impayes.anciennete', 'stock.dispo', 'stock.taux',
  ] },
  { value: 'mensuel', label: 'Mensuel', blocs: [
    'mois.ventes', 'mois.enc', 'mois.liv', 'annee.ventes', 'annee.enc', 'annee.liv',
    'n1.ventes', 'n1.enc', 'coms.classement', 'surv.reliquat', 'surv.bloque',
    'impayes.total', 'impayes.anciennete', 'stock.dispo', 'stock.taux',
  ] },
];

export const WHATSAPP_LIMIT = 1024;
export const RETARD_SEUIL = 50; // % de l'objectif attendu à date (prorata du mois)

const MOIS_LONGS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];

/* ─── Formats ─────────────────────────────────────────────────────────────── */
const nf1 = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 1 });
const nf0 = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 });
// Montant compact : 2,5 M · 354 k · 850 (espaces insécables remplacés pour WhatsApp)
export const fmtMt = (v) => {
  const n = Number(v || 0);
  const a = Math.abs(n);
  const s = a >= 1e6 ? `${nf1.format(n / 1e6)} M` : a >= 1e3 ? `${nf0.format(n / 1e3)} k` : nf0.format(n);
  return s.replace(/ | /g, ' ');
};
export const fmtNb = (v) => nf0.format(Number(v || 0)).replace(/ | /g, ' ');
// % arrondi au supérieur, comme « Performance par commercial » (CEIL)
export const pct = (r, o) => (o > 0 ? Math.ceil((r * 100) / o) : null);
export const fmtPct = (r, o) => { const p = pct(r, o); return p == null ? '—' : `${p} %`; };
export const fmtDateFr = (s) => { const [y, m, d] = String(s).split('-'); return `${d}/${m}/${y}`; };
export const moisLabel = (data) => `${MOIS_LONGS[data.mois - 1]} ${data.annee}`;
const joursDuMois = (data) => new Date(data.annee, data.mois, 0).getDate();
const jourRef = (data) => Number(String(data.date).slice(8, 10));

/* ─── Agrégation ──────────────────────────────────────────────────────────── */
const sumBy = (rows, ids, f) => rows.reduce((s, r) => (ids.has(r.projetId) ? s + (r[f] || 0) : s), 0);
const emptyInd = () => ({ m: { r: 0, o: 0 }, c: { r: 0, o: 0 } });
const addInd = (a, b) => {
  if (!b) return a;
  for (const per of ['m', 'c']) for (const f of ['r', 'o']) a[per][f] += b[per]?.[f] || 0;
  return a;
};

// Chiffres d'un ensemble de projets (objectifs : somme des projets du groupe)
export function aggProjets(data, ids) {
  const h = data.hier, s = data.surveiller;
  const obj = { ventes: emptyInd(), encRecouv: emptyInd(), liv: emptyInd() };
  for (const p of data.objectifs.projets) {
    if (!ids.has(p.projetId)) continue;
    addInd(obj.ventes, p.ventes); addInd(obj.encRecouv, p.encRecouv); addInd(obj.liv, p.liv);
  }
  return {
    hier: {
      ventesNb: sumBy(h.ventes, ids, 'nb'), ventesMt: sumBy(h.ventes, ids, 'montant'),
      encMt: sumBy(h.enc, ids, 'montant'),
      livNb: sumBy(h.liv, ids, 'nb'), livMt: sumBy(h.liv, ids, 'montant'),
      impNb: sumBy(h.impayes, ids, 'nb'), impMt: sumBy(h.impayes, ids, 'montant'),
      desistNb: sumBy(h.desist, ids, 'nb'),
    },
    obj,
    n1: { ventes: sumBy(data.n1.ventes, ids, 'montant'), enc: sumBy(data.n1.enc, ids, 'montant') },
    ptf: { nb7: sumBy(s.ptf, ids, 'nb7'), mt7: sumBy(s.ptf, ids, 'montant7'), nb30: sumBy(s.ptf, ids, 'nb30'), mt30: sumBy(s.ptf, ids, 'montant30') },
    notaire: {
      nb: sumBy(s.notaire, ids, 'nb'), nbReliquat: sumBy(s.notaire, ids, 'nbReliquat'),
      reliquat: sumBy(s.notaire, ids, 'reliquat'), nbBloque: sumBy(s.notaire, ids, 'nbBloque'),
    },
    impayes: {
      nb: sumBy(data.impayesEnCours, ids, 'nb'), mt: sumBy(data.impayesEnCours, ids, 'montant'),
      nb30: sumBy(data.impayesEnCours, ids, 'nb30'), m30: sumBy(data.impayesEnCours, ids, 'm30'),
      nb90: sumBy(data.impayesEnCours, ids, 'nb90'), m90: sumBy(data.impayesEnCours, ids, 'm90'),
      nbPlus: sumBy(data.impayesEnCours, ids, 'nbPlus'), mPlus: sumBy(data.impayesEnCours, ids, 'mPlus'),
    },
    stock: {
      dispo: sumBy(data.stock, ids, 'dispo'), valeur: sumBy(data.stock, ids, 'dispoValeur'),
      bloque: sumBy(data.stock, ids, 'bloque'), vendus: sumBy(data.stock, ids, 'vendus'),
    },
  };
}

export const tauxCommercialisation = (st) => {
  const total = st.vendus + st.dispo + st.bloque;
  return total > 0 ? Math.round((st.vendus * 100) / total) : null;
};

// Groupes selon le découpage : [{ key, label, ville?, ids:Set, agg }]
export function buildGroupes(data, decoupage) {
  const all = new Set(data.projets.map(p => p.id));
  const total = { key: 'total', label: 'Total', ids: all, agg: aggProjets(data, all) };
  if (decoupage === 'ville') {
    const villes = new Map();
    for (const p of data.projets) {
      if (!villes.has(p.villeId)) villes.set(p.villeId, { key: `v${p.villeId}`, label: p.ville, ids: new Set() });
      villes.get(p.villeId).ids.add(p.id);
    }
    return { groupes: [...villes.values()].map(g => ({ ...g, agg: aggProjets(data, g.ids) })), total };
  }
  if (decoupage === 'projet') {
    return {
      groupes: data.projets.map(p => {
        const ids = new Set([p.id]);
        return { key: `p${p.id}`, label: p.nom, ville: p.ville, ids, agg: aggProjets(data, ids) };
      }),
      total,
    };
  }
  return { groupes: [], total };
}

// Commerciaux : objectifs (mois / cumul) + chiffres d'hier par commercial
export function buildCommerciaux(data) {
  const hier = new Map();
  const add = (rows, f, key) => rows.forEach(r => {
    if (r.comId == null) return;
    if (!hier.has(r.comId)) hier.set(r.comId, { ventesNb: 0, ventesMt: 0, encMt: 0, livNb: 0 });
    hier.get(r.comId)[key] += r[f] || 0;
  });
  add(data.hier.ventes, 'nb', 'ventesNb'); add(data.hier.ventes, 'montant', 'ventesMt');
  add(data.hier.enc, 'montant', 'encMt'); add(data.hier.liv, 'nb', 'livNb');
  return data.objectifs.commerciaux.map(c => ({
    ...c,
    hier: hier.get(Number(c.id)) || { ventesNb: 0, ventesMt: 0, encMt: 0, livNb: 0 },
  }));
}

// Commercial avec au moins un réalisé non nul (ventes, enc + recouv, livraisons) sur la période m / c
export const comActif = (c, per = 'm') => !!(c.ventes[per].r || c.encRecouv[per].r || c.liv[per].r);

// Projets dont le réalisé du mois est sous RETARD_SEUIL % de l'objectif attendu à date
export function projetsEnRetard(data) {
  const prorata = jourRef(data) / joursDuMois(data);
  const res = [];
  for (const p of data.objectifs.projets) {
    const items = [['Ventes', p.ventes], ['Enc', p.encRecouv]]
      .map(([label, ind]) => ({ label, attendu: (ind?.m?.o || 0) * prorata, r: ind?.m?.r || 0 }))
      .filter(x => x.attendu > 0 && (x.r * 100) / x.attendu < RETARD_SEUIL);
    if (items.length) {
      const pire = items.reduce((a, b) => (a.r / a.attendu <= b.r / b.attendu ? a : b));
      res.push({ projetId: p.projetId, projet: p.projet, indicateur: pire.label, pctAttendu: Math.round((pire.r * 100) / pire.attendu) });
    }
  }
  return res.sort((a, b) => a.pctAttendu - b.pctAttendu);
}

// Décale une date YYYY-MM-DD de n mois (jour borné à la fin du mois cible)
export const decalerMois = (s, n) => {
  const [y, m, d] = s.split('-').map(Number);
  const fin = new Date(y, m - 1 + n + 1, 0).getDate();
  const r = new Date(y, m - 1 + n, Math.min(d, fin));
  return `${r.getFullYear()}-${String(r.getMonth() + 1).padStart(2, '0')}-${String(r.getDate()).padStart(2, '0')}`;
};

// Périodes de comparaison du mois en cours (1er → jour de référence). calc null = défaut serveur.
export const COMPARAISONS = [
  { value: 'anneePrec', label: 'Même période, année précédente', calc: null },
  { value: 'moisPrec',  label: 'Mêmes dates, mois précédent', calc: (date) => ({ start: decalerMois(`${date.slice(0, 8)}01`, -1), end: decalerMois(date, -1) }) },
  { value: 'perso',     label: 'Personnalisée', calc: null },
];

// Variation « (+12 %) » entre une valeur et sa référence
export const evolution = (r, r1) => (r1 > 0 ? ` (${r >= r1 ? '+' : ''}${Math.round(((r - r1) * 100) / r1)} %)` : '');
// Titre du bloc comparaison (rapports anciens sans `comparaison` : même période N-1)
export const titreComparaison = (data) => {
  const c = data.comparaison;
  if (!c || c.defaut) return `↔️ VS ${MOIS_LONGS[data.mois - 1].toUpperCase()} ${data.annee - 1} (même période)`;
  return `↔️ VS DU ${fmtDateFr(c.start)} AU ${fmtDateFr(c.end)}`;
};

/* ─── Texte du message ────────────────────────────────────────────────────── */
const IND = [
  { key: 'ventes',    bloc: 'ventes', label: 'Ventes',         short: 'V' },
  { key: 'encRecouv', bloc: 'enc',    label: 'Enc. + Recouv.', short: 'Enc' },
  { key: 'liv',       bloc: 'liv',    label: 'Livraisons',     short: 'Livr' },
];

const hasAny = (blocs, prefix) => [...blocs].some(b => b.startsWith(prefix));

// Ligne objectifs compacte d'un groupe : « V 86 % · Enc 70 % · Livr 52 % »
function ligneObjectifs(obj, per, blocs, prefix, format) {
  return IND.filter(i => blocs.has(`${prefix}.${i.bloc}`))
    .map(i => {
      const { r, o } = obj[i.key][per];
      if (!o) return `${i.short} ${fmtMt(r)}`; // pas d'objectif : réalisé seul
      return format === 'court' ? `${i.short} ${fmtPct(r, o)}` : `${i.short} ${fmtMt(r)} (${fmtPct(r, o)})`;
    })
    .join(' · ');
}

function ligneHier(h, blocs) {
  const parts = [];
  if (blocs.has('hier.ventes')) parts.push(`V ${fmtNb(h.ventesNb)} · ${fmtMt(h.ventesMt)}`);
  if (blocs.has('hier.enc'))    parts.push(`Enc ${fmtMt(h.encMt)}`);
  if (blocs.has('hier.liv'))    parts.push(`PN ${fmtNb(h.livNb)}`);
  if (blocs.has('hier.impayes') && h.impNb) parts.push(`⚠️ Imp ${fmtNb(h.impNb)}`);
  return parts.join(' | ');
}

// Listes détaillées (format détaillé) : bloc → clé de data.details
const LISTES = {
  'hier.ventes': 'ventes', 'hier.liv': 'liv', 'hier.enc': 'enc', 'hier.impayes': 'impayes', 'hier.desist': 'desist',
};
export const MAX_LIGNES_LISTE = 8;
const nomProjet = (data, id) => data.projets.find(p => p.id === id)?.nom || `Projet #${id}`;
const dossier = (r) => (r.numDoss ? `N° ${r.numDoss}` : null);
// 2 premiers clients puis « +N » (une part d'association peut en compter beaucoup)
const clientsCourts = (s) => {
  const l = String(s || '').split(' / ').map(x => x.trim()).filter(Boolean);
  return l.length > 2 ? `${l.slice(0, 2).join(' / ')} +${l.length - 2}` : l.join(' / ');
};
const autres = (n) => `   … +${n} autre${n > 1 ? 's' : ''}`;
// « – A · B · C » par ligne (champs vides ignorés), plafonné à MAX_LIGNES_LISTE
const lignesListe = (rows, ligneFn) => {
  const out = rows.slice(0, MAX_LIGNES_LISTE).map(r => `   – ${ligneFn(r).filter(Boolean).join(' · ')}`);
  if (rows.length > MAX_LIGNES_LISTE) out.push(autres(rows.length - MAX_LIGNES_LISTE));
  return out;
};

const hierVide = (h) =>!h.ventesNb && !h.encMt && !h.livNb && !h.impNb && !h.desistNb;

// Détail « dont » des 3 premiers groupes (format détaillé)
const dont = (groupes, f) => {
  const top = groupes.map(g => ({ label: g.label, v: f(g.agg) })).filter(x => x.v > 0)
    .sort((a, b) => b.v - a.v).slice(0, 3);
  return top.length ? ` (dont ${top.map(x => `${x.label} ${fmtNb(x.v)}`).join(', ')})` : '';
};

export function buildTexte(data, { decoupage = 'global', format = 'standard', blocs: blocsArr = [], titre } = {}) {
  if (!data) return '';
  const blocs = new Set(blocsArr);
  const { groupes, total } = buildGroupes(data, decoupage);
  const T = total.agg;
  const coms = decoupage === 'commercial' || hasAny(blocs, 'coms.') ? buildCommerciaux(data) : [];
  const L = [];
  const section = (title, lines) => { if (lines.length) L.push('', title, ...lines); };

  L.push(`📊 ${titre || 'SHEMS — Point du jour'} — ${fmtDateFr(data.date)}`);

  // ── Hier ──
  if (hasAny(blocs, 'hier.')) {
    const lines = [];
    if (decoupage === 'global' || format === 'court') {
      if (format === 'court') {
        lines.push(ligneHier(T.hier, blocs) || '—');
      } else {
        if (blocs.has('hier.ventes')) lines.push(`• Ventes : ${fmtNb(T.hier.ventesNb)} — ${fmtMt(T.hier.ventesMt)} DH`);
        if (blocs.has('hier.enc'))    lines.push(`• Encaissements : ${fmtMt(T.hier.encMt)} DH`);
        if (blocs.has('hier.liv'))    lines.push(`• Passages notaire : ${fmtNb(T.hier.livNb)}`);
      }
    } else if (decoupage === 'commercial') {
      coms.filter(c => c.hier.ventesNb || c.hier.encMt || c.hier.livNb)
        .sort((a, b) => b.hier.ventesMt - a.hier.ventesMt)
        .forEach(c => lines.push(`👤 ${c.commercial} : ${ligneHier({ ...c.hier, impNb: 0 }, blocs)}`));
      if (!lines.length) lines.push('Aucun mouvement commercial');
      lines.push(`= Total : ${ligneHier({ ...T.hier, impNb: 0 }, blocs)}`);
    } else {
      groupes.filter(g => !hierVide(g.agg.hier))
        .forEach(g => lines.push(`${decoupage === 'ville' ? '🏙' : '•'} ${g.label} : ${ligneHier({ ...g.agg.hier, impNb: 0 }, blocs)}`));
      if (!lines.length) lines.push('Aucun mouvement');
      lines.push(`= Total : ${ligneHier({ ...T.hier, impNb: 0 }, blocs)}`);
    }
    if (format !== 'court' && blocs.has('hier.impayes')) {
      lines.push(T.hier.impNb
        ? `• ⚠️ Nouveaux impayés : ${fmtNb(T.hier.impNb)} — ${fmtMt(T.hier.impMt)} DH`
        : '• Aucun nouvel impayé ✅');
    }
    if (blocs.has('hier.desist') && T.hier.desistNb) lines.push(`• Désistements : ${fmtNb(T.hier.desistNb)}`);

    // Format détaillé : projet, n° de dossier, client… de chaque opération d'hier
    if (format === 'detaille' && data.details) {
      const D = data.details;
      const liste = (cle, titre, ligneFn) => {
        if (!blocs.has(cle)) return;
        const rows = (D[LISTES[cle]] || []).filter(r => total.ids.has(r.projetId));
        if (!rows.length) return;
        lines.push('', `📝 ${titre} :`, ...lignesListe(rows, ligneFn));
      };
      const p = (r) => nomProjet(data, r.projetId);
      liste('hier.ventes', 'Ventes', r => [p(r), dossier(r), clientsCourts(r.clients) || r.description,
        `${fmtMt(r.montant)} DH${r.part ? ` (part ${r.part} %)` : ''}`, r.commercial]);
      liste('hier.liv', 'Passages notaire', r => [p(r), dossier(r), clientsCourts(r.clients) || r.description, `${fmtMt(r.montant)} DH`]);
      liste('hier.enc', 'Encaissements', r => [p(r), dossier(r), r.tirePar, r.modeRegl, `${fmtMt(r.montant)} DH`]);
      liste('hier.impayes', 'Impayés', r => [p(r), dossier(r), r.tirePar || 'Tireur inconnu', r.modeRegl, `${fmtMt(r.montant)} DH`]);
      liste('hier.desist', 'Désistements', r => [p(r), dossier(r), clientsCourts(r.clients) || r.description,
        r.association ? "part d'association" : null, `${fmtMt(r.montant)} DH`, r.saisiPar ? `saisi par ${r.saisiPar}` : null]);
    }
    section('🗓 HIER', lines);
  }

  // ── Mois / Année vs objectif ──
  const blocObjectifs = (prefix, per, title) => {
    if (!hasAny(blocs, `${prefix}.`)) return;
    const lines = [];
    if (decoupage === 'global') {
      IND.filter(i => blocs.has(`${prefix}.${i.bloc}`)).forEach(i => {
        const { r, o } = T.obj[i.key][per];
        lines.push(format === 'court'
          ? `• ${i.label} : ${fmtPct(r, o)}`
          : `• ${i.label} : ${fmtMt(r)} / ${fmtMt(o)} DH — ${fmtPct(r, o)}`);
      });
    } else if (decoupage === 'commercial') {
      coms.filter(c => comActif(c, per))
        .sort((a, b) => (pct(b.ventes[per].r, b.ventes[per].o) ?? -1) - (pct(a.ventes[per].r, a.ventes[per].o) ?? -1))
        .forEach(c => lines.push(`👤 ${c.commercial} : ${ligneObjectifs(c, per, blocs, prefix, format)}`));
      lines.push(`= Total : ${ligneObjectifs(T.obj, per, blocs, prefix, format)}`);
    } else {
      let ville = null;
      groupes.forEach(g => {
        if (decoupage === 'projet' && g.ville !== ville) { ville = g.ville; lines.push(`🏙 ${ville}`); }
        const o = g.agg.obj;
        if (!IND.some(i => o[i.key][per].r || o[i.key][per].o)) return;
        lines.push(`${decoupage === 'ville' ? '🏙' : '  •'} ${g.label} : ${ligneObjectifs(o, per, blocs, prefix, format)}`);
      });
      lines.push(`= Total : ${ligneObjectifs(T.obj, per, blocs, prefix, format)}`);
    }
    section(title, lines);
  };
  blocObjectifs('mois', 'm', `📈 ${moisLabel(data).toUpperCase()} (au ${fmtDateFr(data.date).slice(0, 5)})`);
  blocObjectifs('annee', 'c', `📅 CUMUL ${data.annee}`);

  // ── Comparaison (période choisie ; défaut = même période l'année précédente) ──
  if (hasAny(blocs, 'n1.')) {
    const lines = [];
    if (blocs.has('n1.ventes')) lines.push(`• Ventes : ${fmtMt(T.obj.ventes.m.r)} vs ${fmtMt(T.n1.ventes)} DH${evolution(T.obj.ventes.m.r, T.n1.ventes)}`);
    if (blocs.has('n1.enc'))    lines.push(`• Enc. + Recouv. : ${fmtMt(T.obj.encRecouv.m.r)} vs ${fmtMt(T.n1.enc)} DH${evolution(T.obj.encRecouv.m.r, T.n1.enc)}`);
    section(titreComparaison(data), lines);
  }

  // ── Commerciaux ──
  if (hasAny(blocs, 'coms.') && decoupage !== 'commercial') {
    const lines = [];
    const notes = coms.filter(c => c.kind === 'com' && c.ventes.m.o > 0 && comActif(c, 'm'))
      .map(c => ({ c, p: pct(c.ventes.m.r, c.ventes.m.o) }))
      .sort((a, b) => b.p - a.p);
    if (blocs.has('coms.top') && notes.length) {
      lines.push(`🏆 Meilleur : ${notes[0].c.commercial} (${notes[0].p} %)`);
    }
    if (blocs.has('coms.classement')) {
      notes.forEach(({ c }, i) => lines.push(`${i + 1}. ${c.commercial} : ${ligneObjectifs(c, 'm', new Set(['m.ventes', 'm.enc']), 'm', format)}`));
    }
    section('👥 COMMERCIAUX (mois)', lines);
  }

  // ── À surveiller ──
  if (hasAny(blocs, 'surv.')) {
    const lines = [];
    const det = format === 'detaille' && groupes.length > 1;
    // Format détaillé : les 5 lignes les plus importantes sous chaque alerte
    const top = (src, filtre, tri, ligneFn) => {
      if (format !== 'detaille' || !data.details) return [];
      const rows = (data.details[src] || []).filter(r => total.ids.has(r.projetId) && filtre(r)).sort(tri);
      const out = rows.slice(0, 5).map(r => `   – ${ligneFn(r).filter(Boolean).join(' · ')}`);
      if (rows.length > 5) out.push(autres(rows.length - 5));
      return out;
    };
    const p = (r) => nomProjet(data, r.projetId);
    if (blocs.has('surv.ptf') && T.ptf.nb7) {
      lines.push(`• ${fmtNb(T.ptf.nb7)} chèques PTF à échéance sous 7 j : ${fmtMt(T.ptf.mt7)} DH${det ? dont(groupes, a => a.ptf.nb7) : ''}`);
      lines.push(...top('ptf', r => r.dateReglement <= data.seuils.limite7, (a, b) => b.montant - a.montant,
        r => [p(r), dossier(r), r.tirePar, `${fmtMt(r.montant)} DH`, `le ${fmtDateFr(r.dateReglement).slice(0, 5)}`]));
    }
    if (blocs.has('surv.reliquat') && T.notaire.nbReliquat) {
      lines.push(`• ${fmtNb(T.notaire.nbReliquat)} dossiers chez le notaire non soldés — reliquat ${fmtMt(T.notaire.reliquat)} DH`);
      lines.push(...top('notaire', r => r.reliquat > data.seuils.reliquatMin, (a, b) => b.reliquat - a.reliquat,
        r => [p(r), dossier(r), clientsCourts(r.clients), `reliquat ${fmtMt(r.reliquat)} DH`]));
    }
    if (blocs.has('surv.bloque') && T.notaire.nbBloque) {
      lines.push(`• ${fmtNb(T.notaire.nbBloque)} dossiers chez le notaire depuis + ${data.seuils.notaireBloque} j${det ? dont(groupes, a => a.notaire.nbBloque) : ''}`);
      lines.push(...top('notaire', r => r.depot && r.depot < data.seuils.dateBloque, (a, b) => (b.jours || 0) - (a.jours || 0),
        r => [p(r), dossier(r), clientsCourts(r.clients), r.notaire, `${fmtNb(r.jours)} j`]));
    }
    if (blocs.has('surv.retard')) {
      const retard = projetsEnRetard(data).filter(r => total.ids.has(r.projetId));
      if (retard.length) {
        const max = format === 'detaille' ? 10 : 4;
        lines.push(`• Projets en retard : ${retard.slice(0, max).map(r => `${r.projet} (${r.indicateur} ${r.pctAttendu} %)`).join(', ')}${retard.length > max ? ` +${retard.length - max}` : ''}`);
      }
    }
    if (!lines.length && format !== 'court') lines.push('Rien à signaler ✅');
    section('🔔 À SURVEILLER', lines);
  }

  // ── Impayés en cours ──
  if (hasAny(blocs, 'impayes.')) {
    const lines = [];
    const I = T.impayes;
    if (blocs.has('impayes.total')) lines.push(`• Total : ${fmtNb(I.nb)} — ${fmtMt(I.mt)} DH`);
    if (blocs.has('impayes.anciennete')) {
      lines.push(`• ≤ 30 j : ${fmtNb(I.nb30)} (${fmtMt(I.m30)}) · 31–90 j : ${fmtNb(I.nb90)} (${fmtMt(I.m90)}) · + 90 j : ${fmtNb(I.nbPlus)} (${fmtMt(I.mPlus)})`);
    }
    if (format === 'detaille' && groupes.length > 1) {
      groupes.filter(g => g.agg.impayes.nb).sort((a, b) => b.agg.impayes.mt - a.agg.impayes.mt).slice(0, 5)
        .forEach(g => lines.push(`   – ${g.label} : ${fmtNb(g.agg.impayes.nb)} — ${fmtMt(g.agg.impayes.mt)} DH`));
    }
    section('❌ IMPAYÉS EN COURS', lines);
  }

  // ── Stock ──
  if (hasAny(blocs, 'stock.')) {
    const lines = [];
    const ligneStock = (st) => [
      blocs.has('stock.dispo') ? `${fmtNb(st.dispo)} dispo (${fmtMt(st.valeur)} DH)` : null,
      blocs.has('stock.taux') ? `${tauxCommercialisation(st) ?? '—'} % vendu` : null,
    ].filter(Boolean).join(' · ');
    if (decoupage === 'ville' || decoupage === 'projet') {
      groupes.filter(g => g.agg.stock.dispo || g.agg.stock.vendus)
        .forEach(g => lines.push(`• ${g.label} : ${ligneStock(g.agg.stock)}`));
      lines.push(`= Total : ${ligneStock(T.stock)}`);
    } else {
      lines.push(`• ${ligneStock(T.stock)}`);
    }
    section('🏠 STOCK', lines);
  }

  return L.join('\n');
}

export const lienRapport = (token) => `${window.location.origin}/rapport/${token}`;
